var initializeGrantSearchBlock = function(block){

	jQuery('.grants-filters input[type="checkbox"]', block).on('change', function(){
		
		adjustGrantVisibility(block);
		
	});
	
	jQuery('form', block).on('submit', function(e){
		
		e.preventDefault();
		
		adjustGrantVisibility(block);
		
	});
	
	jQuery('.clear').on("click", function(){
		jQuery("#grant-search").val("");
	});

}

function getSearchTerm(block) {

	return jQuery("#grant-search", block).val().toLowerCase();
	
}

function getActiveCategories(block) {
	
	var activeCategories = [];
	
	jQuery('.grants-filters input[type="checkbox"]', block).each(function(){
		
		var current = jQuery(this);
		var isChecked = current[0].checked;
		
		if(isChecked) {
			activeCategories.push(jQuery("+ label", current).html());
		}
		
	});
	
	return activeCategories;
	
}

function adjustGrantVisibility(block) {
	
	var searchTerm = getSearchTerm(block);
	var activeCategories = getActiveCategories(block);
	var count = 0;
	
	jQuery('.grants-table .grants-row:not(.header)', block).each(function(){
		
		var current = jQuery(this);
		var category = jQuery('.column-1', current).html();
		var name = jQuery('.column-2', current).html().toLowerCase();
		var matchesCategory = false;
		var matchesSearch = false;
		
		if(activeCategories.length) {
		
			for(var i = 0; i < activeCategories.length; i++) {
				console.log("Comparing: " + activeCategories[i] + " and " + category);
				if(activeCategories[i] == category) {
					matchesCategory = true;
				}
			}
			
		} else {
			matchesCategory = true;
		}
		
		if(searchTerm) {
			matchesSearch = name.includes(searchTerm);
		} else {
			matchesSearch = true;
		}
		
		if(matchesCategory && matchesSearch) {
			current.removeClass('hide');
			count++;
		} else {
			current.addClass('hide');
		}
		
	});
	
	if(!count) {
		jQuery('.no-results').removeClass('hide');
	} else {
		jQuery('.no-results').addClass('hide');
	}
	
}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-grant-search').each(function(){
		initializeGrantSearchBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=grant-search', initializeGrantSearchBlock);
